import jwt_decode from 'jwt-decode';
import {fromUnixTime} from 'date-fns';

export default {

  isLoggedIn: state => !!state.token,

  claims: state => {
    if (!state.token) {
      return null;
    }
    return jwt_decode(state.token);
  },

  // exp claim given in epoch seconds, not milliseconds.
  tokenExpiryDate: state => {
    if (state.claims && state.claims.exp) {
      return fromUnixTime(state.claims.exp);
    }
    return null;
  },

  /**
   * Find out if the current user has any role in the list of roles given.
   *
   * @param string[] roleNames A list of roles the user should have.
   * @returns boolean true if the user has at least 1 role in the array given.
   */
  hasAnyRoleIn: (state, getters) => (roleNames) => {
    const claims = getters.claims;
    if (!claims || !claims.hasOwnProperty('roles')) {
      return false;
    }
    const roles = claims.roles;

    return roles.some((role) => roleNames.indexOf(role) !== -1)
  },
}
